import _objectSpread from "D:/work/admin/yujian_admin/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/yujian_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Editor from "@/components/Editor";
export default {
  name: "addDownUrl",
  components: {
    Editor: Editor
  },
  data: function data() {
    return {
      form: {
        id: "",
        platform_name: "",
        jump_url: ""
      },
      dialogShow: false,
      phoneList: [{
        label: 'IOS',
        value: 'IOS'
      }, {
        label: 'Android',
        value: 'Android'
      }],
      rules: {
        platform_name: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }],
        jump_url: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }]
      }
    };
  },
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (data) {
                  _this.form = _objectSpread({}, data);
                }

                _this.dialogShow = true;

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    hide: function hide() {
      this.dialogShow = false;
    },
    clearData: function clearData() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.form = {
        id: type ? this.form.id : "",
        platform_name: "",
        jump_url: ""
      };
      this.$refs.ruleForm.resetFields();
    },
    submitData: function submitData() {
      var _this2 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var data = JSON.parse(JSON.stringify(_this2.form));
          var reqFn = _this2.form.id ? 'offWebPkgConfigUpdate' : 'offWebPkgConfigAdd';

          _this2.$api[reqFn](data).then(function (res) {
            if (res.code == 0) {
              _this2.$message({
                message: '操作成功',
                type: 'success'
              });

              _this2.hide();

              _this2.$emit('change');
            }
          });
        }
      });
    }
  }
};